<template>
  <section role="side-modal">
    <side-modal :sides="navs">
      <template :slot="navs[0].identidade">
        <div class="side-body">
          <div class="row row-field">
            <div class="row">
              <div class="col-xs-12 hidden-others">
                <p style="margin: 0 15px 5px; font-size: 16px">
                  <i
                    class="fa fa-check-square-o"
                    aria-hidden="true"
                    style="margin-right: 5px"
                  ></i>
                  <strong>Pendências:</strong>
                </p>
                <div style="padding: 0 15px">
                  <div class="col-xs-4 form-group">
                    <label>Dias</label>
                    <p>{{ ferias.diasPendentes ? 'SIM' : 'NÃO' }}</p>
                  </div>
                  <div class="col-xs-4 form-group">
                    <label>Férias</label>
                    <p>{{ ferias.feriasPendentes ? 'SIM' : 'NÃO' }}</p>
                  </div>
                  <div class="col-xs-4 form-group">
                    <label>Aprovação</label>
                    <p>
                      {{
                        ferias.situacao === 'EM_ANALISE'
                          ? 'EM ANÁLISE'
                          : ferias.situacao
                      }}
                    </p>
                  </div>
                </div>
                <div class="col-xs-12" style="font-size: 1.6rem">
                  <p>
                    <i
                      class="fa fa-calendar"
                      aria-hidden="true"
                      style="margin-right: 5px"
                    ></i>
                    <strong style="margin-right: 15px">
                      Data de início:
                    </strong>
                    <span>
                      {{ escolhidoDia }}/{{ escolhidoMes }}/{{ escolhidoAno }}
                    </span>
                  </p>
                </div>
              </div>
              <div id="calendar" class="col-xs-12">
                <p class="hidden-xxs" style="font-size: 1.6rem">
                  <i class="fa fa-calendar" aria-hidden="true"></i>
                  <strong>Data de início:&nbsp;</strong>
                  <span>
                    {{ escolhidoDia }} de {{ escolhidoMesFull }} de
                    {{ escolhidoAno }}
                  </span>
                </p>
                <section>
                  <header class="calendar-header">
                    <div :class="mostraHeaderMudaMes" @click="toggleMonths()">
                      <span class="hidden-xxs">{{ calendarioMesFull }}</span>
                      <span class="hidden-others">{{ calendarioMesLess }}</span>
                      <i
                        class="fa fa-chevron-down chevron-header"
                        aria-hidden="true"
                        v-show="mostraSetaMudaMes"
                      ></i>
                    </div>
                    <div :class="mostraHeaderMudaAno" @click="toggleYears()">
                      <i
                        class="fa fa-chevron-down chevron-header"
                        aria-hidden="true"
                        v-show="mostraSetaMudaAno"
                      ></i>
                      {{ calendarioAno }}
                    </div>
                  </header>
                  <main class="calendar-body">
                    <div class="chevron-month">
                      <button
                        class="chevron-action"
                        @click="montaCalendario('subtracao')"
                        v-show="mostraSetaMudaMesAnterior"
                      >
                        <i class="fa fa-chevron-left" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div class="calendar">
                      <div class="calendar-month">
                        <button
                          v-for="mes in meses"
                          :key="mes"
                          :class="mudaCorDoMesAno('mes', mes)"
                          @click="marcaMesAno('mes', mes)"
                        >
                          {{ mes }}
                        </button>
                      </div>
                      <div class="calendar-year">
                        <button
                          v-for="ano in anos"
                          :key="ano"
                          :class="mudaCorDoMesAno('ano', ano)"
                          style="font-size: 2.4rem"
                          @click="marcaMesAno('ano', ano)"
                        >
                          {{ ano }}
                        </button>
                      </div>
                      <div
                        class="day-header"
                        :class="coloreSabDomHeader"
                        style="cursor: default"
                      >
                        D
                      </div>
                      <div
                        class="day-header"
                        :class="coloreSegASexHeader"
                        style="cursor: default"
                      >
                        S
                      </div>
                      <div
                        class="day-header"
                        :class="coloreSegASexHeader"
                        style="cursor: default"
                      >
                        T
                      </div>
                      <div
                        class="day-header"
                        :class="coloreSegASexHeader"
                        style="cursor: default"
                      >
                        Q
                      </div>
                      <div
                        class="day-header"
                        :class="coloreSegASexHeader"
                        style="cursor: default"
                      >
                        Q
                      </div>
                      <div
                        class="day-header"
                        :class="coloreSegASexHeader"
                        style="cursor: default"
                      >
                        S
                      </div>
                      <div
                        class="day-header"
                        :class="coloreSabDomHeader"
                        style="cursor: default"
                      >
                        S
                      </div>
                      <button
                        :class="mudaCorDoDia(dia)"
                        :style="
                          index === 0 && `grid-column-start: ${dia.semana + 1}`
                        "
                        v-for="(dia, index) in dias"
                        :key="dia.numero"
                        @click="marcaDia(dia)"
                      >
                        {{ dia.numero }}
                      </button>
                    </div>
                    <div class="chevron-month">
                      <button
                        class="chevron-action"
                        @click="montaCalendario('soma')"
                        v-show="mostraSetaMudaMesPosterior"
                      >
                        <i class="fa fa-chevron-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </main>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div class="side-footer">
          <botao
            tipo="button"
            estilo="cheio-cinza"
            rotulo="Cancelar"
            icone="cancela-modal"
            @clicado="cancela()"
          ></botao>
          <botao
            tipo="button"
            estilo="cheio-verde"
            icone="ok-modal"
            rotulo="Salvar"
            :disabled="salvarDesabilitado"
            @clicado="salva()"
            v-if="ehEditavel"
          ></botao>
          <botao
            tipo="button"
            estilo="cheio-verde"
            icone="fa-file-text-o"
            rotulo="Protocolo"
            @clicado="chamaProtocolo()"
            v-show="!ehEditavel"
          ></botao>
        </div>
      </template>
    </side-modal>
  </section>
</template>

<script>
import Botao from '@/components/botao';
import SideModal from '@/components/side-modal';
import feriadosMock from '../../../static/support/sample-data/feriados.json';
import api from '@/services/api';
import moment from 'moment';

export default {
  name: 'Side-Modal',

  data() {
    return {
      ferias: {},
      calendario: moment(),
      dataMinima: moment(),
      dataEscolhida: null,
      dias: [],
      ehEditavel: true,
      salvarDesabilitado: true,
      navs: [
        {
          titulo: 'Férias',
          subtitulo: 'Período Aquisitivo',
          subtDetalhe: '',
          largura: 600,
          identidade: 'agendamento',
          abreProximo: false,
          aberto: false,
        },
      ],
      feriados: [],
      anoAtual: moment().year(),
      showMonths: false,
      showYears: false,
      meses: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      anos: [],
      numeroMesesAgendaveis: 1,
      numeroMesesVisiveis: 3,
    };
  },

  props: {
    inicioAtividade: {
      required: true,
      type: String,
    },
    inicioSabado: {
      required: true,
      type: Boolean,
    },
    inicioDomingoFeriado: {
      required: true,
      type: Boolean,
    },
  },

  computed: {
    dataMinimaAgendamento() {
      return (
        this.dataMinima.subtract(1, 'days') &&
        this.dataMinima.format('YYYY-MM-DD')
      );
    },
    dataMaximaAgendamento() {
      const dataMinimaMoment = this.dataMinima.add(1, 'days');

      if (this.dataMinima) {
        if (this.numeroMesesAgendaveis === 1) {

          const dataFinal = dataMinimaMoment.clone().endOf('month');
          const quantidadeDiasRestantes = dataFinal.diff(dataMinimaMoment, 'days', true);

          return moment(dataMinimaMoment)
            .add(quantidadeDiasRestantes, 'days')
            .format('YYYY-MM-DD');
        }

        return moment(dataMinimaMoment)
          .add(this.numeroMesesAgendaveis - 1, 'months')
          .add(dataMinimaMoment.daysInMonth(), 'days')
          .format('YYYY-MM-DD');
      }
    },
    dataMinimaVisualizacao() {
      if (this.dataMinimaAgendamento) {
        if (
          this.numeroMesesVisiveis <= this.numeroMesesAgendaveis ||
          this.numeroMesesVisiveis === this.numeroMesesAgendaveis + 1
        ) {
          return this.dataMinimaAgendamento;
        }

        return (
          this.dataMinimaAgendamento &&
          moment(this.dataMinimaAgendamento)
            .date(1)
            .format('YYYY-MM-DD')
        );
      }
    },
    dataMaximaVisualizacao() {
      if (this.dataMaximaAgendamento) {
        if (this.numeroMesesVisiveis <= this.numeroMesesAgendaveis) {
          return this.dataMaximaAgendamento;
        }

        if (this.numeroMesesVisiveis === this.numeroMesesAgendaveis + 1) {
          return moment(this.dataMaximaAgendamento)
            .add(1, 'months')
            .format('YYYY-MM-DD');
        }

        return moment(this.dataMaximaAgendamento)
          .add(
            this.numeroMesesVisiveis - this.numeroMesesAgendaveis - 1,
            'months',
          )
          .format('YYYY-MM-DD');
      }
    },
    dentroPeriodoAgendamento() {
      const primeiroMes = this.calendario.isSame(
        this.dataMinimaAgendamento,
        'month',
      );
      const dentroPeriodoAgendavel = this.calendario.isBetween(
        this.dataMinimaAgendamento,
        this.dataMaximaAgendamento,
        undefined,
        [],
      );

      return primeiroMes || dentroPeriodoAgendavel;
    },
    escolhidoDia() {
      return this.dataEscolhida
        ? this.dataEscolhida.format('DD')
        : this.dataMinima.format('DD');
    },
    escolhidoMes() {
      return this.dataEscolhida
        ? this.dataEscolhida.format('MM')
        : this.dataMinima.format('MM');
    },
    escolhidoMesFull() {
      return this.dataEscolhida
        ? this.dataEscolhida.format('MMMM')
        : this.dataMinima.format('MMMM');
    },
    escolhidoAno() {
      return this.dataEscolhida
        ? this.dataEscolhida.year()
        : this.dataMinima.year();
    },
    calendarioMes() {
      return this.calendario && this.calendario.format('MM');
    },
    calendarioMesLess() {
      return this.calendario && this.calendario.format('MMM');
    },
    calendarioMesFull() {
      return this.calendario && this.calendario.format('MMMM');
    },
    calendarioAno() {
      return this.calendario && this.calendario.year();
    },
    mostraSetaMudaMesAnterior() {
      if (!this.ehEditavel) return false;
      if (this.calendario && this.dataMinimaVisualizacao) {
        return !this.calendario.isSame(this.dataMinimaVisualizacao, 'month');
      }

      return true;
    },
    mostraSetaMudaMesPosterior() {
      if (!this.ehEditavel) return false;
      if (this.calendario && this.dataMaximaVisualizacao) {
        return !this.calendario.isSame(this.dataMaximaVisualizacao, 'month');
      }

      return true;
    },
    mostraSetaMudaMes() {
      if (!this.ehEditavel) return false;

      return this.numeroMesesAgendaveis > 3;
    },
    mostraSetaMudaAno() {
      if (!this.ehEditavel) return false;
      if (this.dataMinimaAgendamento && this.dataMaximaAgendamento) {
        const anoDiferente = !moment(this.dataMinimaAgendamento).isSame(
          this.dataMaximaAgendamento,
          'year',
        );

        return anoDiferente && this.mostraSetaMudaMes;
      }

      return true;
    },
    mostraHeaderMudaMes() {
      return this.mostraSetaMudaMes
        ? 'month-header'
        : 'month-header month-header-readonly';
    },
    mostraHeaderMudaAno() {
      return this.mostraSetaMudaAno
        ? 'year-header'
        : 'year-header year-header-readonly';
    },
    coloreSegASexHeader() {
      return this.dentroPeriodoAgendamento || !this.ehEditavel ? '' : 'weekend';
    },
    coloreSabDomHeader() {
      return this.dentroPeriodoAgendamento || !this.ehEditavel
        ? 'weekend'
        : 'weekend-readonly';
    },
    ehMobile() {
      return window.innerWidth < 520;
    },
  },

  methods: {
    // Métodos de input
    chamaProtocolo() {
      const { protocolo, id: agendamentoId } = this.ferias;
      this.$emit('mostraProtocolo', { protocolo, agendamentoId });
      this.fechaModal('agendamento');
    },
    cancela() {
      this.fechaModal('agendamento');
    },
    confirmaGravacao(inicio, agendamentoId) {
      const sentences = [
        { id: 1, message: 'Essa data será enviada ao seu ', bold: false },
        { id: 2, message: 'superior imediato', bold: true },
        { id: 3, message: ' para aprovação. ', bold: false },
        { id: 4, message: 'Após aprovada,', bold: true },
        {
          id: 5,
          message: 'não poderá ser alterada. ',
          bold: false,
        },
        {
          id: 6,
          message: 'Você deseja enviar a data ',
          bold: false,
        },
        {
          id: 7,
          message: `${this.escolhidoDia}/${this.escolhidoMes}/${
            this.escolhidoAno
          }`,
          bold: true,
        },
        {
          id: 8,
          message: 'para análise?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: () => {
          this.$emit('agendaData', { inicio, agendamentoId });
          this.fechaModal('agendamento');
        },
        title: 'Agendar Férias',
      });
    },
    salva() {
      const inicio = this.dataEscolhida.format('YYYY-MM-DD');
      const agendamentoId = this.ferias.id;

      if (this.bloqueiaSalvamento(inicio)) return;

      this.confirmaGravacao(inicio, agendamentoId);
    },
    marcaDia(dia) {
      if (!this.ehEditavel) return;

      const novaData = moment(this.calendario).date(dia.numero);

      if (this.ehDiaInvalido(dia) || this.ehFeriado(novaData)) return;

      if (!this.valida1AnoDeAtividade(novaData)) {
        this.$root.$refs.toastr.e(
          'Só pode agendar férias depois de completar 1 ano de trabalho',
          'Atenção',
        );
        return;
      }

      if (
        !novaData.isBetween(
          this.dataMinimaAgendamento,
          this.dataMaximaAgendamento,
        )
      )
        return;

      this.salvarDesabilitado = false;
      this.dataEscolhida = novaData;
    },
    marcaMesAno(type, value) {
      if (!this.ehEditavel) return;

      const novaData =
        type === 'mes'
          ? moment(this.calendario).month(value)
          : moment(this.calendario).year(value);

      if (
        !novaData.isBetween(
          this.dataMinimaAgendamento,
          this.dataMaximaAgendamento,
          undefined,
          [],
        )
      )
        return;

      this.salvarDesabilitado = false;
      this.calendario = novaData;
      this.montaCalendario('mudancaMesAno');
      type === 'mes' ? this.toggleMonths() : this.toggleYears();
    },
    toggleMonths() {
      if (!this.ehEditavel) return;

      if (!this.mostraSetaMudaMes) return;

      this.showYears = false;

      if (!this.showMonths) {
        document.querySelector('.calendar-month').classList.add('open');
        document.querySelector('.calendar-year').classList.remove('open');
      } else {
        document.querySelector('.calendar-month').classList.remove('open');
      }

      this.showMonths = !this.showMonths;
    },
    toggleYears() {
      if (!this.ehEditavel) return;

      if (!this.mostraSetaMudaAno) return;

      this.showMonths = false;

      if (!this.showYears) {
        document.querySelector('.calendar-year').classList.add('open');
        document.querySelector('.calendar-month').classList.remove('open');
      } else {
        document.querySelector('.calendar-year').classList.remove('open');
      }

      this.showYears = !this.showYears;
    },

    // Métodos de validações
    valida1AnoDeAtividade(dataAnalisada) {
      const dataPermitida = moment(this.inicioAtividade).add(1, 'years');

      return (moment(dataAnalisada).isAfter(dataPermitida) 
        || moment(dataAnalisada).isSame(dataPermitida));
    },
    validaDepoisDaDataMinima(dataEscolhida, dataMinima) {
      return moment(dataEscolhida).isSameOrAfter(dataMinima);
    },
    bloqueiaSalvamento(inicio) {
      if (!this.valida1AnoDeAtividade(inicio)) {
        this.$root.$refs.toastr.e(
          'Só pode agendar férias depois de completar 1 ano de trabalho',
          'Atenção',
        );
        return true;
      }

      const dia = {
        numero: moment(inicio).date(),
        semana: moment(inicio).day(),
      };

      if (!this.validaDepoisDaDataMinima(inicio, this.dataMinima)) {
        this.$root.$refs.toastr.e('Escolha uma data válida', 'Atenção');
        return true;
      }

      if (this.ehDiaInvalido(dia)) {
        const primeiroDia = this.inicioDomingoFeriado
          ? 'domingo'
          : 'segunda-feira';
        const ultimoDia = this.inicioSabado ? 'sábado' : 'sexta-feira';
        this.$root.$refs.toastr.e(
          `Escolha um dia entre ${primeiroDia} e ${ultimoDia}`,
          'Atenção',
        );
        return true;
      }

      if (this.ehFeriado(moment(inicio))) {
        this.$root.$refs.toastr.e(
          `Escolha um dia que não seja feriado`,
          'Atenção',
        );
        return true;
      }

      return false;
    },
    ehDiaInvalido(dia) {
      const domingo = dia.semana === 0 && !this.inicioDomingoFeriado;
      const sabado = dia.semana === 6 && !this.inicioSabado;

      return domingo || sabado;
    },
    ehFeriado(dataInicio) {
      const data = dataInicio.format('YYYY-MM-DD');
      const dataEhFeriado = this.feriados.some(
        feriado => feriado.data === data,
      );
      const naoPermiteAgendarNoFeriado = !this.inicioDomingoFeriado;

      return dataEhFeriado && naoPermiteAgendarNoFeriado;
    },

    // Métodos de leitura de dados
    async listaFeriados(anos) {
      try {
        const endPointFeriados = `feriados-pontos-facultativos`;
        const anosJoined = anos.join(',');
        const queryParams = {params: {anos: anosJoined}};
        const feriadosResponse = await api.get(endPointFeriados, queryParams);

        return feriadosResponse.length && feriadosResponse;
      } catch (error) {
        const message = error.data[0].message;

        this.$root.$refs.toastr.e(message, 'Atenção');
      }
    },

    // Métodos handle
    trataDataInicio(inicio) {
      if (this.ehEditavel) {
        const dataPermitida = moment(this.inicioAtividade).add(1, 'years');
        const hoje = moment();
        const dataInicio = moment(inicio);

        this.dataMinima = moment.max(dataPermitida, hoje, dataInicio);
        this.calendario = moment.max(dataPermitida, hoje, dataInicio);

        return;
      }

      this.dataEscolhida = moment(inicio);
      this.calendario = moment(inicio);
    },
    limpaTogglesMesAno() {
      this.showMonths = false;
      this.showYears = false;
      document.querySelector('.calendar-month').classList.remove('open');
      document.querySelector('.calendar-year').classList.remove('open');
    },
    limpaSideModal() {
      setTimeout(() => {
        this.dataEscolhida = null;
        this.limpaTogglesMesAno();
        this.salvarDesabilitado = true;
      }, 600);
    },
    montaCalendario(operacao) {
      const data = this.calendario.clone();

      if (operacao === 'soma') data.add(1, 'months');
      this.salvarDesabilitado = false;
      if (operacao === 'subtracao') data.subtract(1, 'months');

      this.calendario = data.clone();

      let diasNoMes = data.daysInMonth();
      const diasArray = [];

      while (diasNoMes) {
        const cadaDia = {};
        const current = data.date(diasNoMes);
        cadaDia.numero = current.date();
        cadaDia.semana = current.day();

        diasArray.push(cadaDia);
        diasNoMes--;
      }

      this.dias = diasArray.reverse();
    },
    listaAnos() {
      let ano = moment(this.dataMinimaVisualizacao).year();
      const ultimoAno = moment(this.dataMaximaVisualizacao).year();
      const anosArray = [];

      while (ano <= ultimoAno) {
        anosArray.push(ano);
        ano++;
      }

      this.anos = [...anosArray];
    },
    mudaCorDoDia(dia) {
      const diaCalendario = moment(this.calendario).date(dia.numero);

      if (this.ehEditavel) {
        if (
          (this.ehDiaInvalido(dia) || this.ehFeriado(diaCalendario)) &&
          !this.dentroPeriodoAgendamento
        )
          return 'day weekend-readonly';

        if (
          this.ehDiaInvalido(dia) ||
          this.ehFeriado(diaCalendario) ||
          !diaCalendario.isBetween(
            this.dataMinimaAgendamento,
            this.dataMaximaAgendamento,
          )
        )
          return 'day weekend';

        if (
          this.dataEscolhida &&
          dia.numero === this.dataEscolhida.date() &&
          this.calendario.isSame(this.dataEscolhida, 'month', 'year')
        )
          return 'day active';

        return 'day';
      }

      if (this.ehDiaInvalido(dia) || this.ehFeriado(diaCalendario)) {
        return 'readonly weekend';
      }

      if (diaCalendario.isSame(this.dataEscolhida)) return 'readonly active';

      return 'readonly';
    },
    async trataFeriados() {
      const listaFeriados = await this.listaFeriados(this.anos);
      this.feriados = [...listaFeriados];
    },
    mudaCorDoMesAno(type, value) {
      if (!this.ehEditavel) return;

      const novaData =
        type === 'mes'
          ? moment(this.calendario).month(value)
          : moment(this.calendario).year(value);

      if (type === 'mes' && value === this.calendarioMesFull)
        return 'month-year active';

      if (type === 'ano' && value === this.calendarioAno)
        return 'month-year active';

      if (
        novaData.isBetween(
          this.dataMinimaAgendamento,
          this.dataMaximaAgendamento,
          undefined,
          [],
        )
      )
        return 'month-year';

      return 'month-year weekend';
    },

    // Outros métodos
    abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
      this.limpaSideModal();
    },
  },

  async created() {
    this.$parent.$on(
      'abreModal',
      async ({ identidade, ferias, inicio, editavel }) => {
        this.ehEditavel = editavel;
        this.trataDataInicio(inicio);
        this.montaCalendario();
        this.listaAnos();
        this.navs[0].subtDetalhe = ferias.periodo.toString();
        this.ferias = ferias;
        this.salvarDesabilitado = true;
        await this.trataFeriados();
        this.abreModal(identidade);
      },
    );
  },

  components: {
    Botao,
    SideModal,
  },
};
</script>

<style scoped>
.calendar-header {
  display: flex;
  justify-content: space-between;
  margin: 16px 34px 0;
}

.calendar-body {
  display: grid;
  grid-template-columns: 30px auto 30px;
}

.chevron-month {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.chevron-header {
  font-size: 16px;
  vertical-align: middle;
}

.chevron-action {
  color: #ccc;
  font-size: 24px;
  background: transparent;
  height: 150px;
  border: none;
  transition: color 0.2s;
}

.chevron-action:hover {
  color: #666;
}

.chevron-action:focus {
  outline: none !important;
}

.calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  flex-wrap: wrap;
  margin-bottom: 16px;
  position: relative;
}

.calendar-month,
.calendar-year {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(6, 1fr);
  grid-auto-flow: column;
  overflow: hidden;
  background: #fff;
  width: 40px;
  height: 0;
  font-size: 1.2em;
  position: absolute;
  top: 0;
  left: 0;
  transition: height 0.3s, width 0.3s, font-size 0.3s;
}

.calendar-year {
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  grid-template-rows: auto;
  left: unset;
  right: 0;
}

.calendar .open {
  height: 100%;
  width: 100%;
  font-size: 2em;
}

.month-header,
.year-header,
.month-header-readonly,
.year-header-readonly {
  color: #cccccc;
  font-weight: 800;
  font-size: 4rem;
  letter-spacing: -0.3rem;
  cursor: pointer;
}

.year-header,
.year-header-readonly {
  text-align: right;
}

.month-header-readonly,
.year-header-readonly {
  cursor: default;
}

.month-year,
.day,
.day-header,
.readonly,
.readonly-month-year {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 12px;
  margin: 2px;
  background-color: #dae8d7;
  height: 45px;
  font-size: 1.8rem;
  transition: color 0.2s, background-color 0.2s;
}

.month-year {
  height: auto;
  font-size: 2rem;
}

.day-header {
  font-weight: bold;
}

.day:hover,
.month-year:hover {
  background-color: #f0f5ed;
  color: #00302d;
}

.day:focus,
.month-year:focus,
.active {
  background-color: #00615c;
  color: #fff;
  font-weight: bold;
  outline: unset;
}

.weekend,
.weekend-readonly,
.weekend:hover,
.weekend:focus {
  background-color: #d7dad7;
  color: #fff;
  font-weight: bold;
  cursor: not-allowed;
}

.weekend-readonly,
.weekend-readonly:hover,
.weekend-readonly:focus {
  background-color: #b5b7b5;
  color: #fff;
}

.readonly,
.readonly-month-year {
  cursor: not-allowed;
}

.readonly-month-year {
  height: auto;
}

.readonly:focus,
.readonly-month-year:focus {
  outline: unset;
}

.hidden-others {
  display: none;
}

@media screen and (max-width: 520px) {
  #calendar {
    padding: 0;
  }

  .hidden-xxs {
    display: none;
  }

  .hidden-others {
    display: inline-block;
    padding: 0;
  }
}

@media screen and (max-width: 425px) {
  .day,
  .day-header,
  .readonly {
    height: 38px;
  }

  .month-year {
    font-size: 1.8rem;
  }
}

@media screen and (max-width: 348px) {
  .month-header,
  .year-header {
    font-size: 3.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// side-modal.vue?19f1e22c